import { render, staticRenderFns } from "./IndikatorKegiatan.vue?vue&type=template&id=1bbac5f2&"
import script from "./IndikatorKegiatan.vue?vue&type=script&lang=js&"
export * from "./IndikatorKegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports